module.exports = __webpack_public_path__ + "assets/images/project/ang-mo-kio-ave1/02.jpg?v=1158dbe8";